import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { changeForm } from '../../redux/actions';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';

class PaymentInit {
  static init(sessionId, props)
  {
      const self = this;

      /*window.PagSeguroDirectPayment.setSessionId(sessionId);

      window.PagSeguroDirectPayment.onSenderHashReady(function (response)
      {
          if (response.status == 'error')
          {
              const strings = STRINGS[window.LANGUAGE];
              const msg = {
                title: strings.atencao,
                text: response.message
              };
              Dialog.create(msg);
              return false;
          }

          const _hash = response.senderHash; //Hash estará disponível nesta variável.
          const { changeForm } = props;
          changeForm(_hash, 'senderHash');

      });*/
  }
}

const mapStateToProps = store => ({
  ...store.formState
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ changeForm }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PaymentInit);



// WEBPACK FOOTER //
// ./src/classes/cadastro/PaymentInit.js